<template>
  <b-navbar toggleable="lg" type="dark" variant="primary" class="navbar">
    <b-navbar-brand class="logo">
      <router-link :to="{ name: 'rooms-list'}">
        <img src="@/assets/bing8-logo.png" alt="">
      </router-link>
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item>
          <router-link :to="{ name: 'rooms-list'}">Salas</router-link>
        </b-nav-item>

      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <!-- <b-nav-item-dropdown text="Lang" right>
          <b-dropdown-item href="#">ES</b-dropdown-item>
          <b-dropdown-item href="#">EN</b-dropdown-item>
        </b-nav-item-dropdown> -->

        <b-nav-item-dropdown right v-if="currentUser && currentUser.displayName">
          <template v-slot:button-content>
            {{ currentUser.username || currentUser.displayName}}
          </template>
          <!-- <b-dropdown-item href="#">Profile</b-dropdown-item> -->
          <b-dropdown-item @click="logout">Salir</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapState } from 'vuex';
const fb = require("../firebaseConfig.js");
export default {
  name: "NavBar",
  computed: mapState(['currentUser']),
  methods: {
    logout() {
      fb.auth().signOut().then(() => {
        this.$store.commit('setCurrentUser', {});
        this.$router.push('/');
      })
    }
  }
};
</script>

<style scoped lang="scss">
.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
  box-shadow: 0 9px 9px 0 rgba(153, 153, 153, .32);
}
.logo {
  img {
    height: 20px;
  }
}
</style>
